enum RedemptionEventOptions {
  UsersDateOfBirth = "USERS_DATE_OF_BIRTH"
}

export enum RedemptionEventDeal {
  BirthdayBox = "80b51138-5ce0-4c97-981e-541729e29022"
}

export default RedemptionEventOptions
